import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ErrorIcon from '@mui/icons-material/Error';

const statusMap = {
	complete: {
		color: 'success',
		icon: <CheckCircleIcon sx={{ fontSize: 16 }} />,
	},
	processing: {
		color: 'info',
		icon: <HourglassEmptyIcon sx={{ fontSize: 16 }} />,
	},
	error: { color: 'error', icon: <ErrorIcon sx={{ fontSize: 16 }} /> },
	pending: {
		color: 'warning',
		icon: <HourglassEmptyIcon sx={{ fontSize: 16 }} />,
	},
};

export default function StatusChip({ status }) {
	const { color, icon } = statusMap[status] || { color: 'default', icon: null };
	return (
		<Chip
			icon={icon}
			label={status}
			size='small'
			color={color}
			sx={{
				ml: 1,
				textTransform: 'capitalize',
				fontSize: '0.7rem',
			}}
		/>
	);
}

StatusChip.propTypes = {
	status: PropTypes.string.isRequired,
};
